export default __webpack_public_path__ + "static/media/j_wdt_c_2.3529ebd5.mp3";